import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { isFunction } from '../../utils/TypeUtils';
import { ActionIconButton } from './internal/ActionIconButton';
import IconWithClickAnimation from './internal/IconWithClickAnimation';
import CopyMessageActionButton from './internal/CopyMessageActionButton';
import InlineFeedbackPopover from './internal/InlineFeedbackPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const POSITIVE_FEEDBACK = 1;
const NEGATIVE_FEEDBACK = -1;
const InlineFeedback = ({
  hideCopyButton = false,
  copyMessage,
  messageId,
  onPositiveFeedback,
  onNegativeFeedback,
  usageTracker
}) => {
  const [draftVote, setDraftVote] = useState();
  const [feedbackPopoverOpen, setFeedbackPopoverOpen] = useState(false);
  const handlePositiveFeedback = useCallback(() => {
    const isPositiveFeedbackSelected = draftVote === POSITIVE_FEEDBACK;
    if (isPositiveFeedbackSelected) {
      usageTracker.track('feedbackInteraction', {
        action: 'prompt_upvote_removed'
      });
      setDraftVote(null);
    } else {
      usageTracker.track('feedbackInteraction', {
        action: 'prompt_upvoted'
      });
      setDraftVote(POSITIVE_FEEDBACK);
    }
    if (isFunction(onPositiveFeedback)) {
      onPositiveFeedback({
        messageId,
        vote: 1
      });
    }
  }, [draftVote, messageId, onPositiveFeedback, usageTracker]);
  const handleNegativeFeedbackClick = useCallback(() => {
    const isNegativeFeedbackSelected = draftVote === NEGATIVE_FEEDBACK;
    if (isNegativeFeedbackSelected) {
      usageTracker.track('feedbackInteraction', {
        action: 'prompt_downvote_removed'
      });
      setDraftVote(null);
    } else {
      usageTracker.track('feedbackInteraction', {
        action: 'prompt_downvoted'
      });
      setDraftVote(NEGATIVE_FEEDBACK);
      setFeedbackPopoverOpen(true);
    }
  }, [draftVote, usageTracker]);
  const handleClose = useCallback(() => {
    setFeedbackPopoverOpen(false);
  }, []);
  const handleSubmit = ({
    options,
    message: feedbackMessage
  }) => {
    setFeedbackPopoverOpen(false);
    if (isFunction(onNegativeFeedback)) {
      onNegativeFeedback({
        messageId,
        options,
        feedbackMessage,
        vote: -1
      });
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      "data-test-id": "inline-feedback",
      children: [/*#__PURE__*/_jsx(ActionIconButton, {
        "aria-pressed": draftVote === POSITIVE_FEEDBACK,
        "data-test-id": "positive-feedback-button",
        selected: draftVote === POSITIVE_FEEDBACK,
        onClick: handlePositiveFeedback,
        placement: "bottom",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiComponentsUiLibrary.components.inlineFeedback.positiveFeedback.tooltip"
        }),
        use: "tertiary-extra-light",
        size: "sm",
        style: {
          border: 'none',
          marginLeft: 0
        },
        children: /*#__PURE__*/_jsx(IconWithClickAnimation, {
          name: "thumbsUp"
        })
      }), /*#__PURE__*/_jsx(InlineFeedbackPopover, {
        popoverOpen: feedbackPopoverOpen,
        onSubmit: handleSubmit,
        onCancel: handleClose,
        children: /*#__PURE__*/_jsx(ActionIconButton, {
          "aria-pressed": draftVote === NEGATIVE_FEEDBACK,
          "data-test-id": "negative-feedback-button",
          selected: draftVote === NEGATIVE_FEEDBACK,
          onClick: handleNegativeFeedbackClick,
          placement: "bottom",
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.negativeFeedback.tooltip"
          }),
          use: "tertiary-extra-light",
          size: "sm",
          style: {
            border: 'none',
            marginLeft: 0
          },
          children: /*#__PURE__*/_jsx(IconWithClickAnimation, {
            name: "thumbsDown"
          })
        })
      }), !hideCopyButton && copyMessage && /*#__PURE__*/_jsx(CopyMessageActionButton, {
        message: copyMessage,
        usageTracker: usageTracker
      })]
    })
  });
};
export default InlineFeedback;